import type { GraphEdgeSettingsId, HideableNodeType } from './graphSettings';

/**
 * List of edge settings ids & device types present in graph
 * used for contextual visualization settings
 */
export interface AvailableGraphEntities {
  edgeSettingsIds: GraphEdgeSettingsId[];
  deviceTypes: HideableNodeType[];
}
